import React from "react"
import {
  Image, Menu, MenuButton, MenuList,
} from "@chakra-ui/react"
import { DioboxEvent } from "sharedTypes"
import en from "assets/images/add-to-calendar/en.svg"
import de from "assets/images/add-to-calendar/de.svg"
import es from "assets/images/add-to-calendar/es.svg"
import fr from "assets/images/add-to-calendar/fr.svg"
import it from "assets/images/add-to-calendar/it.svg"
import nl from "assets/images/add-to-calendar/nl.svg"
import pt from "assets/images/add-to-calendar/pt.svg"
import tr from "assets/images/add-to-calendar/tr.svg"
import MenuItemLink from "./MenuItemLink"

type Props = {
  event: DioboxEvent
}

const AddToCalendar = ({ event: { attachIcs, language } }: Props) => {
  if (!attachIcs) {
    return null
  }

  const imageMap: Record<string, string> = {
    en,
    de,
    es,
    fr,
    it,
    nl,
    pt,
    tr,
  }

  return (
    <Menu>
      <MenuButton>
        <Image
          src={imageMap[language]}
          alt="Add to Calendar"
          height={41}
        />
      </MenuButton>
      <MenuList minW={32}>
        <MenuItemLink>
          Apple
        </MenuItemLink>
        <MenuItemLink>
          Google
        </MenuItemLink>
        <MenuItemLink>
          Outlook
        </MenuItemLink>
        <MenuItemLink>
          Yahoo
        </MenuItemLink>
      </MenuList>
    </Menu>
  )
}

export default AddToCalendar
